import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import usePageTitle from '../hooks/usePageTitle';

const SebiRegistrationDetailsPage = () => {
  usePageTitle('SEBI Registration Details');
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <Header />
      <main id="main-content" tabIndex={-1} className="pt-32 pb-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-gray-500 hover:text-[#C8473A] mb-8 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" aria-hidden="true" />
            Back to Home
          </Link>

          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 md:p-12 text-[#211F1F]">
            <p className="text-sm text-gray-500 uppercase tracking-wider mb-2">
              YourNest Capital Advisors Pvt. Ltd.
            </p>
            <h1 className="text-3xl md:text-4xl font-bold text-[#211F1F] mb-4">
              SEBI REGISTRATION DETAILS
            </h1>
            <div className="mb-10 border-b border-gray-200 pb-6" />

            <div className="prose prose-gray max-w-none text-[15px] leading-relaxed space-y-8">
              <p>
                YourNest manages multiple AIF funds. Details are as follows:
              </p>

              <div>
                <h2 className="text-xl font-bold text-[#211F1F] mt-2 mb-2">YourNest Angel Fund</h2>
                <p className="mb-1"><strong>SEBI Regn. No.:</strong> IN/AIF1/25-26/1874</p>
                <p><strong>Category of AIF:</strong> Category I (Migrated VCF)</p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-[#211F1F] mt-2 mb-2">YourNest India VC Fund II</h2>
                <p className="mb-1"><strong>SEBI Regn. No.:</strong> IN/AIF1/16-17/0267</p>
                <p><strong>Category of AIF:</strong> Category I</p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-[#211F1F] mt-2 mb-2">YourNest Innovative Products VC Fund III</h2>
                <p className="mb-1"><strong>SEBI Regn. No.:</strong> IN/AIF2/20-21/0863</p>
                <p><strong>Category of AIF:</strong> Category II</p>
              </div>

              <div>
                <h2 className="text-xl font-bold text-[#211F1F] mt-2 mb-2">YourNest Continuum Fund I</h2>
                <p className="mb-1"><strong>SEBI Regn. No.:</strong> IN/AIF2/25-26/1919</p>
                <p><strong>Category of AIF:</strong> Category II</p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default SebiRegistrationDetailsPage;
